import { render, staticRenderFns } from "./transferOfOwnerSuccessPg.vue?vue&type=template&id=792223da&scoped=true"
import script from "./transferOfOwnerSuccessPg.vue?vue&type=script&lang=js"
export * from "./transferOfOwnerSuccessPg.vue?vue&type=script&lang=js"
import style0 from "./transferOfOwnerSuccessPg.vue?vue&type=style&index=0&id=792223da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792223da",
  null
  
)

export default component.exports